import React, { useEffect, useState } from 'react'
import styles from './areUDoctor.module.scss';
import { Col, Container, Row } from 'react-bootstrap';


const AreUDoctor = (props) => {

    console.log(props, "are you dr")
    return (
        <>
            <section className={`${styles.areUDoctor} areUDoctor bg-white`} style={{ background: props?.widgetData?.data[0]?.card_1_inner_color }}>
                <Container className='h-100'>
                    <Row className='h-100 justify-content-center'>
                        <Col lg={12}>
                            <div className={`${styles.cont__fad} areUDoctor_fad`}>
                                <Col lg={6} className={`${styles.col__left} areUDoctor_ord`}>
                                    <h2> {props?.widgetData?.data?.[0]?.heading} </h2>
                                    <div className={`${styles.gaps} d-flex flex-wrap `}>
                                        {props?.widgetData?.data?.slice(1)?.map((item) => {
                                            return (
                                                <div className={styles.mainAreYDrBox}>
                                                    <div className={`${styles.boxSlid01} boxSlid01aft`}>
                                                        <img src={item?.image} width={80} height={80} className='img-fluid' />

                                                        <h3>{item?.heading}</h3>

                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </Col>
                                <Col lg={6} className='text-end'>
                                    {props?.widgetData?.data?.[0]?.image && <img src={props?.widgetData?.data?.[0]?.image} width={471.998} height={501.231} alt='' className={`${styles.right_botm_pam_img} areUDoctor_img`} />}
                                </Col>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>)
}

export default AreUDoctor;
